'use client';

import { useEffect } from 'react';

export const useElementObserver = (
  $element: React.RefObject<HTMLElement | null>,
  callback: (entry: ResizeObserverEntry) => void,
) => {
  useEffect(() => {
    if (!$element.current) return;

    const resizeObserver = new ResizeObserver(([entry]) => callback(entry));

    resizeObserver.observe($element.current);
    return () => resizeObserver.disconnect();
  }, [$element.current]);

  return $element;
};
